import React from 'react';
import MobileSidebar from './mobile';
import SideBar from './sidebar';

export default (props) => {
  return (
    <div>
      <SideBar {...props} />
      <MobileSidebar {...props} />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/views/recalls-list/side-bar/index.js